import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "popup"
}

import GoalDone from "@/components/Goal/GoalDone.vue";
import {onMounted, ref} from "vue";
import CongratulationPopup from "@/ts/Popup/CongratulationPopup";


export default /*@__PURE__*/_defineComponent({
  __name: 'GoalDonePopup',
  setup(__props) {


const isShowed = ref(false);
const popup = ref<HTMLDivElement>();
onMounted(() => {
  CongratulationPopup.getInstance().init(isShowed, popup.value!);
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["popup-wrapper", {show: isShowed.value}]),
    ref_key: "popup",
    ref: popup
  }, [
    (isShowed.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(GoalDone)
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})